import { ApiStatus } from "../types/api/status"
import { useDispatch, useSelector } from "../redux/store"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"
import { readLocalStorage } from "../toolbox/helpers/local-storage-helpers"
import { LocalStorageKey } from "../types"
import { changeStatus, onSetSelectedCountry, selectUbigeoState, setAction, onFetchDistricts } from "../redux/slices/UbigeoSlice"
import { Country } from "../types/slices/ubigeoType"
import { UbigeoAPI } from "../apis/UbigeoAPI"

export const useUbigeoStore = () => {

    const dispatch = useDispatch()
    const { countries, departments, provinces, districts, status, action } = useSelector(selectUbigeoState)

    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const idcompany = userData?.idcompany

    const getCountries = async (search='') => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await UbigeoAPI.getCountries({search:search})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const getDepartments = async (search='', idcountry='') => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await UbigeoAPI.getDepartments({search:search, idcountry:idcountry})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const getProvinces = async (search='', iddepartment='') => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await UbigeoAPI.getProvinces({search:search, iddepartment:iddepartment})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const getDistricts = async (search='', idprovince='') => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await UbigeoAPI.getDistricts({search:search, idprovince:idprovince})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(onFetchDistricts(detail))
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const setSelectedCountry = (country: Country) => {
        try {
            dispatch(onSetSelectedCountry(country))
        } catch (error) {
            console.log(error)
        }
    }

    const setActionUbigeo = (state) => {
        try {
            dispatch(setAction(state))
        } catch (error) {
            console.log(error)
        }
    }

    return {
        //states
        countries,
        departments,
        provinces,
        districts,
        status,
        action,
        //actions
        getCountries,
        getDepartments,
        getProvinces,
        getDistricts,
        setSelectedCountry,
        setActionUbigeo,
    }
}